import React from "react";
import EventList from "../../Components/EventList";

const Events = () => {
  return <EventList />;
};

export default Events;
